// This is exported through bingadsHeaderLocalization
export const customerSelectorLocalization = {
  CustomerSelector_ViewAllCustomers: _TL_('View all customers'),
  CustomerSelector_ManageCustomers: _TL_('Manage access'),
  CustomerSelector_Default: _TL_('Default customer'),
  CustomerSelector_Recent: _TL_('Recently viewed customers'),
  CustomerSelector_DefaultCustomerDisplayNameFormat: _TL_('{0} (default)'),
  CustomerSelector_SingleAccountCountText: _TL_('{0} account'),
  CustomerSelector_MultipleAccountsCountText: _TL_('{0} accounts'),
  CustomerSelector_Loading: _TL_('Loading ...'),
  Customers_Selection_SearchBox_DefaultText: _TL_('Enter customer name or ID'),
  ManagerAccount_Selection_SearchBox_DefaultText: _TL_('Enter manager account name, number or ID'),
};

export const bingadsHeaderLocalization = {
  Header_Title: _TL_('Microsoft Advertising'),
  Header_Skip: _TL_('Skip to main content'),
  BingadsHeader_Gear_Tooltip: _TL_('Accounts & Billing, My Settings, Sign Out, Contact Us, Start Live Chat'),
  Header_Gear_Tooltip_NewUI: _TL_('Billing & Payments, Account Access, Settings, Sign Out, Contact Us, Start Live Chat'),
  BingadsHeader_AccountAccess: _TL_('Account Access'),
  BingadsHeader_BillingAndPayments: _TL_('Billing & Payments'),
  BingadsHeader_ManagerAccounts: _TL_('View All Manager Accounts'),
  BingadsHeader_Accounts: _TL_('Accounts & Billing'),
  BingadsHeader_MySettings: _TL_('My Settings'),
  BingadsHeader_NotificationSettings: _TL_('Notification Settings'),
  BingadsHeader_CentralizedSettings: _TL_('Settings'),
  BingadsHeader_Feedback: _TL_('Send Feedback'),
  BingadsHeader_Support: _TL_('Support'),
  BingadsHeader_LogOut: _TL_('Sign Out'),
  BingadsHeader_AccountsSummary_Caption: _TL_('Accounts Summary'),
  BingadsHeader_AccountsSummary_ToolTip: _TL_('Accounts Summary'),
  BingadsHeader_ManagerDashboard_Caption: _TL_('Accounts'),
  BingadsHeader_ManagerDashboard_ToolTip: _TL_('Accounts'),
  BingadsHeader_Home_Caption: _TL_('Home'),
  BingadsHeader_Home_ToolTip: _TL_('Home'),
  BingadsHeader_Ucm_Caption: _TL_('Dashboard'),
  BingadsHeader_Ucm_ToolTip: _TL_('Dashboard'),
  BingadsHeader_Campaign_Caption: _TL_('Campaigns'),
  BingadsHeader_Campaign_ToolTip: _TL_('Campaigns'),
  BingadsHeader_Reports_Caption: _TL_('Reports'),
  BingadsHeader_Reports_ToolTip: _TL_('Reports'),
  BingadsHeader_Opportunity_Caption: _TL_('Opportunities'),
  BingadsHeader_Opportunity_ToolTip: _TL_('Opportunities'),
  BingadsHeader_Tools_Caption: _TL_('Tools'),
  BingadsHeader_Tools_ToolTip: _TL_('Tools'),
  BingadsHeader_Import_New_Caption: _TL_('Import Campaigns'),
  BingadsHeader_Import_New_ToolTip: _TL_('Import Campaigns'),
  BingadsHeader_Import_Caption: _TL_('Import from Google Ads'),
  BingadsHeader_Import_ToolTip: _TL_('Import from Google Ads'),
  BingadsHeader_ImportFile_Caption: _TL_('Import from file'),
  BingadsHeader_ImportFile_ToolTip: _TL_('Import from file'),
  BingadsHeader_ImportSchedule_Caption: _TL_('Import schedule and history'),
  BingadsHeader_ImportSchedule_ToolTip: _TL_('Import schedule and history'),
  BingadsHeader_Help: _TL_('Help'),
  BingadsHeader_CrossAccountSearch_Caption: _TL_('Search across accounts'),
  BingadsHeader_CrossAccountSearch_ToolTip: _TL_('Search across accounts'),
  BingadsHeader_AccountInfoManageLocation_Caption: _TL_('Manage your business locations'),
  BingadsHeader_AccountInfoManageLocation_ToolTip: _TL_('Manage your business locations'),
  BingadsHeader_Desktop_Caption: _TL_('Microsoft Advertising Editor'),
  BingadsHeader_Desktop_ToolTip: _TL_('Save time by managing your Microsoft Advertising campaigns in an easy-to-use desktop application. '),
  BingadsHeader_ExcelAddIn_Caption: _TL_('Microsoft Advertising Intelligence'),
  BingadsHeader_ExcelAddIn_ToolTip: _TL_('Research and optimize keywords by using our add-in for Microsoft Excel 2007 or later. '),
  BingadsHeader_AdPreview_Caption: _TL_('Ad Preview and Diagnostics Tool'),
  BingadsHeader_AdPreview_ToolTip: _TL_('See if your ads show up on the first page of Bing, and review reasons why your ads might not be showing.'),
  BingadsHeader_KeywordResearch_Caption: _TL_('Research Keywords'),
  BingadsHeader_KeywordResearch_ToolTip: _TL_('Automatically generate new keywords from words or website addresses you type.'),
  BingadsHeader_Analytics_Caption: _TL_('Campaign Analytics'),
  BingadsHeader_Analytics_ToolTip: _TL_('Set campaign goals and analyze conversion-tracking statistics on your website.'),
  BingadsHeader_Cashback_Caption: _TL_('Microsoft Merchant Center'),
  BingadsHeader_Cashback_ToolTip: _TL_('Create store catalogs so your products can display on Bing.'),
  BingadsHeader_AdsLab_Caption: _TL_('Ads Lab'),
  BingadsHeader_AdsLab_ToolTip: _TL_('Get early access into new extensions that Microsoft Advertising is exploring.'),
  BingadsHeader_Cam_Caption: _TL_('Creative Asset Manager'),
  BingadsHeader_Cam_ToolTip: _TL_('Upload and manage creatives for use in your ad campaigns.'),
  BingadsHeader_SegmentBuilder_Caption: _TL_('Segment Builder'),
  BingadsHeader_SegmentBuilder_ToolTip: _TL_('Target audiences that are relevant to your ad campaigns by creating custom segments.'),
  BingadsHeader_KeywordPlanner_Caption: _TL_('Keyword Planner'),
  BingadsHeader_KeywordPlanner_ToolTip: _TL_('Find more keywords and research their popularity.'),
  BingadsHeader_BusinessPortal_Caption: _TL_('Business Profile (beta)'),
  BingadsHeader_BusinessPortal_ToolTip: _TL_('Business Profile (beta)'),
  BingadsHeader_HotelCenter_Caption: _TL_('Microsoft Hotel Center'),
  BingadsHeader_HotelCenter_ToolTip: _TL_('Microsoft Hotel Center'),
  BingadsHeader_AudienceDashboard_Caption: _TL_('Audience Network Planner'),
  BingadsHeader_AudienceDashboard_ToolTip: _TL_('Audience Network Planner'),
  BingadsHeader_SwitchExpertMode: _TL_('Switch to Expert Mode'),
  New_Feature_Label: _TL_('NEW!'),
  AccountSelector_AllAccountsTitle: _TL_('All accounts'),
  AccountSelector_Search_Placeholder: _TL_('Search all accounts'),
  AccountSelector_RecentsTitle: _TL_('Recent'),
  AccountSelector_Loading: _TL_('Loading ...'),
  AccountSelector_SwitchAccountsMessage: _TL_('Click to switch accounts'),
  AccountSelector_ShowInactiveAccountsMessage: _TL_('Show inactive accounts'),
  AccountSelector_ManagingCustomerNumberDisplayFormat: _TL_('Manager account: {0}'),
  AccountSelector_ManagingAccountNumberDisplayFormat: _TL_('Account: {0}'),
  BingadsHeader_TryUIVNext: _TL_('Try the new Microsoft Advertising'),
  ...customerSelectorLocalization,
};

export const feedbackLocalization = {
  Feedback_Email: _TL_('Your email address'),
  Feedback_Message: _TL_('Message'),
  Feedback_IncludeScreenshot: _TL_('Include screenshot'),
  Feedback_Dialog_SendButton: _TL_('Send'),
  Feedback_AdditonInformationHint: _TL_("We've collected some additional information to diagnose problems."),
  Feedback_AdditonInformationLink: _TL_('Additional information'),
  Feedback_SuccessfulMessage: _TL_('Your feedback was sent successfully!'),
  Feedback_FailedMessage: _TL_("Something was wrong with feedback service. You can click the 'Feedback' link at the bottom of page to post your feedback on our portal."),
  Feedback_Dialog_CancelButton: _TL_('Cancel'),
  Feedback_Dialog_Title: _TL_('Send feedback'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
};

export const validationLocalization = {
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Min_Length: _TL_('Field should exceed {{minlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_BigInt_Require_BigInt_Type: _TL_('Field requires numeric value'),
  Validation_BigInt_Max_Length: _TL_('Number should not exceed max length'),
  Validation_BigInt_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  Validation_BigInt_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_BigInt_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Require_Numeric: _TL_('Field requires numeric value'),
  Validation_Number_Max_Length: _TL_('Number should not exceed max length'),
  Validation_Number_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_Number_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  Validation_Array_Size_Max: _TL_('List should have at most {{max}} items'),
  Validation_Array_Size_Between: _TL_('List should have at least {{min}} and at most {{max}} items'),
  Validation_Array_Items_Invalid: _TL_('Some of items in list are invalid'),
  Validation_Array_Items_Duplicate: _TL_('List has duplicate items'),
  Validation_NegativeKeywords_ListName_Required: _TL_('The list name is required.'),
  Validation_NegativeKeywords_Max_Count: _TL_('Maximum of 5,000 negative keywords'),
  Validation_NegativeKeywords_Invalid_Keywords: _TL_('Some of the keyword(s) are invalid: {{invalidKeywords}}'),
  Validation_NegativeKeywords_Required: _TL_('At least 1 negative keyword is required.'),
};

export const simpleFormLocalization = {
  SimpleForm_Button_Save: _TL_('Save'),
  SimpleForm_Button_Cancel: _TL_('Cancel'),
  SimpleForm_TotalRemainingCharactersText: _TL_('{{count}} characters remaining for {{fields}}'),
  SimpleForm_TotalRemainingCharactersText_FieldsList: _TL_('{{initial}} and {{last}}'),
  SimpleForm_LearnMore: _TL_('Click to learn more about {{item}}'),
};

export const requestCallModalLocalization = {
  RequestCallModal_Continue: _TL_('Continue'),
  RequestCallModal_Cancel: _TL_('Cancel'),
  RequestCallModal_Close: _TL_('Close'),
  RequestCallModal_CallMeBack: _TL_('Call me back'),
  RequestCallModal_ReasonForCall: _TL_('How can we help you?'),
  RequestCallModal_Description: _TL_('Description'),
  RequestCallModal_Description_Placeholder: _TL_('Add more information so we can help you quickly.'),
  RequestCallModal_AdvertiserSupport: _TL_('I need help with Microsoft Advertising or have a general question'),
  RequestCallModal_AgencySupport: _TL_('I am an agency managing clients on Microsoft Advertising'),
  RequestCallModal_AdultSupport: _TL_('Adult Support'),
  RequestCallModal_ComplexSupportScenario: _TL_('I have a question about Microsoft Shopping campaign or conversion tracking'),
  RequestCallModal_OnboardingConsult: _TL_('Onboarding Consult'),
  RequestCallModal_OptimizationConsult: _TL_('I want coaching on how to optimize my campaign performance'),
  RequestCallModal_AgencyConsultation: _TL_('Agency Consultation'),
  RequestCallModal_SmartCampaign: _TL_('I need help with Smart campaigns or have a general question'),
  RequestCallModal_DMCSupport: _TL_('I need help with Digital Marketing Center or have a general question'),
  RequestCallModal_UPSupport: _TL_('I need help with Multiplatform campaigns or have a general question'),
  RequestCallModal_SmartPageSupport: _TL_('I need help with Smart Pages or have a general question'),
  RequestCallModal_DialogReadyLabel: _TL_('Call me back dialog is ready'),
};

export const msSupportChatLocalization = {
  MsSupportChatModal_Continue: _TL_('Continue'),
  MsSupportChatModal_Cancel: _TL_('Cancel'),
  MsSupportChatModal_Close: _TL_('Close'),
  MsSupportChatModal_Title: _TL_('Start a live chat'),
  MsSupportChatModal_Description: _TL_('Description'),
  MsSupportChatModal_Description_Placeholder: _TL_('Add more information so we can help you quickly.'),
  MsSupportChatModal_VirtualAgent_WelcomeMessage: _TL_("Hi! I'm a Microsoft Advertising Virtual Agent. I'd love to help you. Please do not include any sensitive information during our conversation."),
  MsSupportChatModal_DialogReadyLabel: _TL_('Start a live chat dialog is ready'),
  RequestCallModal_ReasonForCall: _TL_('How can we help you?'),
  RequestCallModal_AdvertiserSupport: _TL_('I need help with Microsoft Advertising or have a general question'),
  RequestCallModal_AgencySupport: _TL_('I am an agency managing clients on Microsoft Advertising'),
  RequestCallModal_AdultSupport: _TL_('Adult Support'),
  RequestCallModal_ComplexSupportScenario: _TL_('I have a question about Microsoft Shopping campaign or conversion tracking'),
  RequestCallModal_OnboardingConsult: _TL_('Onboarding Consult'),
  RequestCallModal_OptimizationConsult: _TL_('I want coaching on how to optimize my campaign performance'),
  RequestCallModal_AgencyConsultation: _TL_('Agency Consultation'),
  RequestCallModal_SmartCampaign: _TL_('I need help with Smart campaigns or have a general question'),
  RequestCallModal_DMCSupport: _TL_('I need help with Digital Marketing Center or have a general question'),
  RequestCallModal_UPSupport: _TL_('I need help with Multiplatform campaigns or have a general question'),
  RequestCallModal_SmartPageSupport: _TL_('I need help with Smart Pages or have a general question'),
  RequestCallModal_ConversionTracking: _TL_('I need help with conversion tracking'),
  Warning: _TL_('Warning'),
  MsSupportChatModal_BR_Alert: _TL_('We are currently experiencing high volume of Portuguese chat requests. In the meantime, you can go back to the help menu and request English support that is available 24/7.'),
  MsSupportChatModal_EN_Alert: _TL_('We are experiencing higher than normal chat volume and will assist you as soon as possible. Thank you for your patience.'),
};

export const switchExpertModalLocalization = {
  SwitchForm_Close: _TL_('Close'),
  SwitchExpertModal_Header: _TL_('Are you sure you want to switch to Expert Mode?'),
  SwitchExpertModal_BodyLabel: _TL_('Expert Mode lets you take advantage of all the features Microsoft Advertising has to offer, such as:'),
  SwitchExpertModal_Feature1: _TL_('Add more content to your ads '),
  SwitchExpertModal_Feature2: _TL_('More detailed reporting and conversion tracking'),
  SwitchExpertModal_Feature3: _TL_('Automated bid strategies and other tools to increase efficiency'),
  SwitchExpertModal_LinkLearnMore: _TL_('Learn more about Smart mode vs. Expert mode.'),
  SwitchExpertModal_ButtonStay: _TL_('Stay in Smart mode'),
  SwitchExpertModal_ButtonSwitch: _TL_('Switch to Expert mode'),
};

export const BingAdsHeaderStrings = {
  ...bingadsHeaderLocalization,
  ...feedbackLocalization,
  ...validationLocalization,
  ...simpleFormLocalization,
  ...requestCallModalLocalization,
  ...msSupportChatLocalization,
  ...switchExpertModalLocalization,
};
